module.exports = __webpack_public_path__ + "img/SOA.79743415.jpg";